/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Flow_Out_StateInputs */

const en_services_flow_out_state = /** @type {(inputs: Services_Flow_Out_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepared`)
};

const lv_services_flow_out_state = /** @type {(inputs: Services_Flow_Out_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sagatavots`)
};

/**
* | output |
* | --- |
* | "Prepared" |
*
* @param {Services_Flow_Out_StateInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_flow_out_state = /** @type {((inputs?: Services_Flow_Out_StateInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Flow_Out_StateInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_flow_out_state(inputs)
	return en_services_flow_out_state(inputs)
});